import { LogLevel } from '@azure/msal-browser';
import { aadClientId, aadEndpointHost, aadTenantId, authRedirectUri } from '../config/env';

const msalConfig = {
  auth: {
    clientId: `${aadClientId}`,
    authority: `${aadEndpointHost}${aadTenantId}`,
    redirectUri: authRedirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {},
      piiLoggingEnabled: false,
      logLevel: LogLevel.Error,
    },
  },
};

export default msalConfig;
